import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const AboutScreen = () => {
  return (
    <div sx={{ flexGrow: 1, padding: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h2" gutterBottom sx={{ mb: 2 }}>
            About Madecare: medical!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Welcome to Madecare, where knowledge meets fun! Dive into an
            exhilarating journey of learning and challenge your intellect with
            over 1000+ diverse and captivating questions. Whether you're
            passionate about history, science, literature, or more, Madecare
            offers something for everyone.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Solo Mode: Embark on a personal quest to conquer various categories
            and chapters. Test your skills, beat challenging bosses, and earn
            rewards as you progress. Each victory not only enhances your
            knowledge but also unlocks new levels of achievement.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Arena Mode: Experience the thrill of real-time competition in Arena
            Mode! Engage in daily-changing categories, compete against up to
            four opponents simultaneously, and rise through the ranks on the
            leaderboard. Quick thinking and accuracy are your allies as you aim
            to outscore and outsmart your rivals.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            At Madecare, we prioritize your data safety and privacy. We adhere
            to stringent security measures and transparent data practices to
            ensure that your personal information is safeguarded at all times.
            Our commitment extends to regularly updating our privacy policies
            based on user feedback and evolving regulatory standards.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Your feedback matters! We continuously strive to enhance your gaming
            experience based on your valuable suggestions. One area of focus has
            been optimizing notifications during gameplay in Arena Mode. We are
            actively refining this feature to minimize interruptions while
            maximizing engagement and enjoyment.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Join a vibrant community of trivia enthusiasts and sharpen your
            knowledge prowess with Madecare! Challenge friends, discover new
            interests, and embark on an educational adventure like no other.
            Download Madecare today and unlock the endless possibilities of
            learning through play!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Thank you for choosing Madecare. Let's embark on a journey where
            every question is a step towards greater knowledge, every
            competition a chance to excel, and every experience an opportunity
            to grow. Welcome to Madecare – where learning is fun and knowledge
            is rewarded!
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default AboutScreen;
